import { render, staticRenderFns } from "./astana-club.vue?vue&type=template&id=a4370e3e&scoped=true&"
import script from "./astana-club.vue?vue&type=script&lang=js&"
export * from "./astana-club.vue?vue&type=script&lang=js&"
import style0 from "./astana-club.vue?vue&type=style&index=0&id=a4370e3e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4370e3e",
  null
  
)

export default component.exports